"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToLogin = exports.getAppRoute = exports.isAppChange = void 0;

var isAppChange = function isAppChange(link, app) {
  return !window.location.href.includes("/".concat(app)) && (link === null || link === void 0 ? void 0 : link.includes("/".concat(app))) || window.location.href.includes("/".concat(app)) && !(link !== null && link !== void 0 && link.includes("/".concat(app)));
};

exports.isAppChange = isAppChange;

var getAppRoute = function getAppRoute() {
  if (window.location.href.includes("/remote-health")) {
    return "/remote-health";
  }

  if (window.location.href.includes("/nomad-health")) {
    return "/nomad-health";
  }

  if (window.location.href.includes("/medical-directory")) {
    return "/medical-directory";
  }

  if (window.location.href.includes("/blog")) {
    return "/blog";
  }

  if (window.location.href.includes("/perks")) {
    return "/perks";
  }

  return "";
};

exports.getAppRoute = getAppRoute;

var navigateToLogin = function navigateToLogin(mainSiteUrl, isRemoteHealth, isNomadHealth, isNomadInsurance, isRemoteDoctor) {
  if (typeof window === "undefined") {
    return;
  }

  if (isRemoteHealth) {
    window.location.href = "".concat(mainSiteUrl, "/remote-health/login");
    return;
  }

  if (isNomadHealth) {
    window.location.href = "".concat(mainSiteUrl, "/nomad-health/login");
    return;
  }

  if (isNomadInsurance) {
    window.location.href = "".concat(mainSiteUrl, "/nomad-insurance/login");
    return;
  }

  if (isRemoteDoctor) {
    window.location.href = "".concat(mainSiteUrl, "/remote-doctor/login");
  }

  window.location.href = "".concat(mainSiteUrl, "/login");
};

exports.navigateToLogin = navigateToLogin;